
  var style = require("icon-maker-loader/.tmp/0a2f764c-24f4-42c4-9868-1a0d858032dd/icon-maker.js");
  var mainClass = style["icon-maker"];
  if (mainClass) {
    module.exports = mainClass + " " + style["icon-maker-arrow-big-down"];
  } else {
    module.exports = "icon-maker icon-maker-arrow-big-down";
  }
  


//////////////////
// WEBPACK FOOTER
// ./src/icons/arrow-big-down.svg
// module id = 527
// module chunks = 5